import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { TASK_TYPES_LABELS } from '../../api/admin/types';
const ClipboardTaskRow = ({ clipboardTask }) => {
    const { i18n, t } = useTranslation();
    return (_jsxs("div", { className: "clipboard-task-row", children: [_jsx("div", { className: "clipboard-task-type", children: t(`${TASK_TYPES_LABELS[clipboardTask.type]}`) }), _jsxs("div", { className: "clipboard-task-title", children: [_jsx("div", { className: "clipboard-task-public-title", children: clipboardTask.title[i18n.language] }), clipboardTask.internalTitle && (_jsx("div", { className: "clipboard-task-internal-title", children: `${clipboardTask.internalTitle}` }))] })] }));
};
export default ClipboardTaskRow;
